import React from 'react';
import GenericModal from '@components/common/modals/GenericModal';
import Button from '@components/common/Button';
import styles from './ReassociateConfirmationModal.module.css';

interface ReassociateConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  contractNumber: string;
  oldSupplierName: string;
  newSupplierName: string;
  isLoading?: boolean;
  error?: string | null;
}

const ReassociateConfirmationModal: React.FC<ReassociateConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  contractNumber,
  oldSupplierName,
  newSupplierName,
  isLoading = false,
  error = null
}) => {
  return (
    <GenericModal
      isOpen={isOpen}
      onClose={onClose}
      title="Confirm Supplier Change"
      size="sm"
      disableBackdropClick={isLoading}
    >
      <div className={styles.content}>
        <p className={styles.confirmationMessage}>
          Replace <strong>{oldSupplierName}</strong> with <strong>{newSupplierName}</strong> for contract{' '}
          <strong>{contractNumber}</strong>?
        </p>

        {error && <div className={styles.confirmationError}>{error}</div>}

        <div className={styles.confirmationActions}>
          <Button variant="secondary" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? 'Confirming...' : 'Confirm'}
          </Button>
        </div>
      </div>
    </GenericModal>
  );
};

export default ReassociateConfirmationModal;
